import React from 'react';
import { Save, RefreshCw, ExternalLink, LogOut } from 'lucide-react';

/**
 * Admin Dashboard Header Component
 */
const AdminHeader = ({ admin, saving, onSave, onLogout }) => {
  return (
    <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-4">
            <h1 className="text-xl font-bold text-slate-900">Admin CMS</h1>
            <span className="text-sm text-slate-500">Welcome, {admin?.name}</span>
          </div>
          <div className="flex items-center gap-4">
            <a
              href="/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sm text-slate-600 hover:text-slate-900"
            >
              <ExternalLink className="w-4 h-4" /> View Site
            </a>
            <button
              onClick={onSave}
              disabled={saving}
              data-testid="publish-button"
              className="flex items-center gap-2 bg-slate-900 text-white px-4 py-2 rounded-lg font-medium hover:bg-slate-800 disabled:opacity-50"
            >
              {saving ? (
                <RefreshCw className="w-4 h-4 animate-spin" />
              ) : (
                <Save className="w-4 h-4" />
              )}
              {saving ? 'Publishing...' : 'Publish'}
            </button>
            <button
              onClick={onLogout}
              data-testid="logout-button"
              className="flex items-center gap-2 text-slate-600 hover:text-slate-900"
            >
              <LogOut className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
